import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getProveedor, toggleProveedorActivo } from "../../services/proveedoresService";
import "./Proveedores.css";

const ProveedorDetalle = () => {
  const { provId } = useParams();
  const navigate = useNavigate();
  const [p, setP] = useState(null);

  useEffect(() => {
    (async () => setP(await getProveedor(provId)))();
  }, [provId]);

  if (!p) return <div className="prov-page"><div className="prov-panel">Cargando…</div></div>;

  return (
    <div className="prov-page">
      <div className="prov-panel">
        <div className="prov-head">
          <div>
            <h2>{p.nombre || "Proveedor"}</h2>
            {!p.activo && <span className="prov-badge">Inactivo</span>}
          </div>
          <div className="prov-head-actions">
            <button className="btn btn-secondary" onClick={() => navigate(`/app/proveedores/${provId}/editar`)}>Editar</button>
            <button
              className={p.activo ? "btn btn-danger" : "btn btn-primary"}
              onClick={async () => {
                await toggleProveedorActivo(provId, !p.activo);
                setP({ ...p, activo: !p.activo });
              }}
            >
              {p.activo ? "Desactivar" : "Reactivar"}
            </button>
          </div>
        </div>

        <div className="prov-detail">
          <div><span>Contacto:</span> <b>{p.contacto || "—"}</b></div>
          <div><span>Teléfono:</span> <b>{p.telefono || "—"}</b></div>
          <div><span>Email:</span> <b>{p.email || "—"}</b></div>
          <div><span>RFC:</span> <b>{p.rfc || "—"}</b></div>
          <div><span>Dirección:</span> <b>{p.direccion || "—"}</b></div>
          <div><span>Notas:</span> <b>{p.notas || "—"}</b></div>
        </div>

        <div className="prov-actions-line">
          <button className="btn btn-secondary" onClick={() => navigate(-1)}>← Volver</button>
          <button
            className="btn btn-primary"
            onClick={() => navigate("/app/cxp/nueva", { state: { proveedorId: p.id, proveedorNombre: p.nombre || "" } })}
          >
            Usar en CxP
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProveedorDetalle;
